import { useFormik } from 'formik';
import React from 'react';
import Phone from '../../Components/UI/Phone';
import { cellNumberSchema } from '../../Schema';
import AlertModal from '../AlertModal';
import ModalAction from '../ModalAction';
import classes from './ChangedSecondaryPhoneNumber.module.css';
const initialValues = {
  cellNumber: ''
};
const ChangedSecondaryNumberModal = ({ onSubmit, setShow, data, show, loading }) => {
  const formik = useFormik({
    initialValues,
    validationSchema: cellNumberSchema,
    onSubmit: (values, { resetForm }) => {
      const params = {
        secondaryCountryCode: values?.cellNumber?.slice(0, 3),
        secondaryCellNumber: values?.cellNumber.slice(3)
      };
      onSubmit(params, () => {
        setShow();
        resetForm();
      });
    }
  });
  const { touched, errors, values, handleSubmit, resetForm, setFieldValue, setFieldTouched } =
    formik;
  const handleChangeWithTouch = (field, value) => {
    setFieldValue(field, value);
    setFieldTouched(field, true, false); // Mark field as touched manually
  };
  const onCancel = () => {
    setShow(false);
    resetForm();
  };
  return (
    <AlertModal title={'Secondary Number'} show={show} setShow={setShow} actions={false}>
      <form onSubmit={handleSubmit}>
        <Phone
          label=""
          placeholder={'+92 XXX XXXXXXX'}
          isOptional={true}
          errorText={touched?.cellNumber && errors?.cellNumber}
          value={values?.cellNumber}
          setter={(e) => {
            handleChangeWithTouch('cellNumber', e);
          }}
          id="cell-number-changed"
        />
        <ModalAction
          type="submit"
          isApiCall={loading}
          className={classes.actions}
          onCancel={() => {
            if (typeof onCancel === 'function') onCancel();
          }}
        />
      </form>
    </AlertModal>
  );
};

export default ChangedSecondaryNumberModal;
